import React, { useContext } from 'react';
import { Button, Input } from 'antd';
import debounce from 'lodash.debounce';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OperationType } from '../types/SelectedOperation';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import { ProductAlertsContext } from '../ProductAlertsProvider';
import styles from './Header.module.less';

const { Search } = Input;

export const Header: React.FC = ({ children }) => {
  const { user } = useAppStateContext();
  const { changeSearchBySegmentName, setSelectedOperation } = useContext(ProductAlertsContext);
  const readOnlyMode = user?.appPermissions['read_only_product_alert'];

  const onSearchSegment = (value: string): void => {
    changeSearchBySegmentName(value);
  };
  const onDebounce = debounce((value: string) => {
    changeSearchBySegmentName(value);
  }, 1000);
  const onChangeName = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onDebounce(event.target.value);
  };

  const handleCreateSegment = () => {
    if (readOnlyMode) return;
    setSelectedOperation({ type: OperationType.CreateSegment });
  };

  return (
    <div className={styles.header}>
      <Button type="primary" onClick={handleCreateSegment} disabled={readOnlyMode}>
        <FontAwesomeIcon icon={['fal', 'plus']} size="lg" style={{ marginRight: '10px' }} /> Create New Segment
      </Button>

      <Search
        className={styles.header__search}
        placeholder="Add more keywords to refine your results"
        onSearch={onSearchSegment}
        onChange={onChangeName}
        allowClear
      />

      {children}
    </div>
  );
};
